import type { PropsWithChildren, ReactElement } from "react";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";

import { StyledManagementCardTag } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";

interface IProps {
    iconName?: IconName;
}

const ManagementCardFilterTag = ({ iconName, children }: PropsWithChildren<IProps>): ReactElement => {
    return (
        <StyledManagementCardTag>
            {iconName ? (
                <SWReactIcons
                    iconName={iconName}
                    size="xs"
                />
            ) : null}

            {children}
        </StyledManagementCardTag>
    );
};

export default ManagementCardFilterTag;
